import { atom } from 'jotai';

import type { AddressLookupProps } from '@origin-digital/address-lookup';

export const addressLookupStatusAtom = atom<AddressLookupProps['endIcon']>('');

export const addressLookupInProgressAtom = atom<boolean>(
  (get) => get(addressLookupStatusAtom) === 'validating'
);
